import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';

import { NativeAdDefaultProps, NativeAdPropTypes, VERTICAL_ALIGN } from './ad-unit-prop-types';
import { AdUnit } from './ad-unit';

const NATIVE_FED_TEST = 'nativefedtest';

const AD_CONTAINER_HEIGHTS = {
  mrect: '282px',
  mmrect: '312px',
  mediumrectangle: '268px',
  mspot: '122px',
  spot: '122px',
  sponsoredvideo: '363px',
  msponsoredvideo: '363px',
  enhancedspot: '198px',
  vdp: '144px',
  filmstripincentive: '174px',
  'vdp,filmstripincentive': '174',
  filmstripincentivecore: '104px',
  filmstrip: '358px',
  edhighimpact: '288px',
  medhighimpact: '221px',
  billboard: '250px',
  leaderboard: '90px',
};

function NativeAdUI({
  wrapperClass = NativeAdDefaultProps.wrapperClass,
  adNameWired = NativeAdDefaultProps.adNameWired,
  adNameMobile = NativeAdDefaultProps.adNameMobile,
  wiredBreakpoints = NativeAdDefaultProps.wiredBreakpoints,
  mobileBreakpoints = NativeAdDefaultProps.mobileBreakpoints,
  wiredOnly = NativeAdDefaultProps.wiredOnly,
  mobileOnly = NativeAdDefaultProps.mobileOnly,
  mobile = NativeAdDefaultProps.mobile,
  slotRenderEndListener = NativeAdDefaultProps.slotRenderEndListener,
  placeholderComponent = NativeAdDefaultProps.placeholderComponent,
  placeholderComponentProps = NativeAdDefaultProps.placeholderComponentProps,
  customTargeting = NativeAdDefaultProps.customTargeting,
  isMobile,
  nativeFedTestFlag = NativeAdDefaultProps.nativeFedTestFlag,
  position = NativeAdDefaultProps.position,
  nativeStyle,
  refreshDisableWhenZipChanged = NativeAdDefaultProps.refreshDisableWhenZipChanged,
  siteServedAdsUpdater = NativeAdDefaultProps.siteServedAdsUpdater,
  dco = NativeAdDefaultProps.dco,
  showLabel = NativeAdDefaultProps.showLabel,
  renderWhenViewable = NativeAdDefaultProps.renderWhenViewable,
  refreshWhenViewable = NativeAdDefaultProps.refreshWhenViewable,
  noRefresh = NativeAdDefaultProps.noRefresh,
  useMinHeight = NativeAdDefaultProps.useMinHeight,
  altMinHeight = NativeAdDefaultProps.altMinHeight,
  customSizes = NativeAdDefaultProps.customSizes,
  customSizesWired = NativeAdDefaultProps.customSizesWired,
  customSizesMobile = NativeAdDefaultProps.customSizesMobile,
  addCustomSizes = NativeAdDefaultProps.addCustomSizes,
  addCustomSizesWired = NativeAdDefaultProps.addCustomSizesWired,
  addCustomSizesMobile = NativeAdDefaultProps.addCustomSizesMobile,
  verticalAlign = NativeAdDefaultProps.verticalAlign,
  isSmall = NativeAdDefaultProps.isSmall,
  refreshZones = NativeAdDefaultProps.refreshZones,
  lazyLoad = NativeAdDefaultProps.lazyLoad,
  currentVehicle = NativeAdDefaultProps.currentVehicle,
  style = {},
  ...restProps
}) {
  const name = isMobile ? adNameMobile : adNameWired;
  const breakpoints = isMobile ? mobileBreakpoints : wiredBreakpoints;
  const showOnCurrentLayout = (isMobile && !wiredOnly) || (!isMobile && !mobileOnly);
  const renderedAdType = nativeStyle !== 'none' ? nativeStyle : name;
  const customSizesByBreakpoint = isMobile ? customSizesMobile : customSizesWired;
  const addCustomSizesByBreakpoint = isMobile ? addCustomSizesMobile : addCustomSizesWired;

  const containerStyles = {
    minHeight: altMinHeight || AD_CONTAINER_HEIGHTS[renderedAdType],
    overflow: 'visible',
  };

  const adName = nativeFedTestFlag ? NATIVE_FED_TEST : name;

  const adUnitProps = {
    adName,
    nativeStyle,
    position,
    ...breakpoints,
    ...restProps,
    mobile,
    slotRenderEndListener,
    placeholderComponent,
    placeholderComponentProps,
    customTargeting,
    refreshDisableWhenZipChanged,
    siteServedAdsUpdater,
    dco,
    showLabel,
    renderWhenViewable,
    refreshWhenViewable,
    noRefresh,
    renderOnScroll: false,
    isSmall,
    refreshZones,
    lazyLoad,
    currentVehicle,
    rerenderWhenViewable: false,
    customSizes: customSizesByBreakpoint || customSizes,
    addCustomSizes: addCustomSizesByBreakpoint || addCustomSizes,
  };

  return (
    showOnCurrentLayout && (
      <div
        className={classnames('native-ad-wrapper', wrapperClass, {
          'd-flex justify-content-center': !!verticalAlign && verticalAlign !== VERTICAL_ALIGN.TOP,
          'align-items-center': verticalAlign === VERTICAL_ALIGN.CENTER,
          'align-items-end': verticalAlign === VERTICAL_ALIGN.BOTTOM,
          'd-flex justify-content-center align-items-start': verticalAlign === VERTICAL_ALIGN.TOP,
        })}
        data-viewability={`${nativeStyle}-${position}`}
        data-renderwhenviewable={false}
        style={{ ...style, ...(useMinHeight ? containerStyles : null) }}
      >
        <AdUnit {...adUnitProps} />
      </div>
    )
  );
}

NativeAdUI.propTypes = {
  ...NativeAdPropTypes,
  style: PropTypes.shape({}),
};

export const mapStateToProps = state => ({
  isMobile: state.mobile,
  nativeFedTestFlag: state.featureFlags.nativeFedTest,
});
export const NativeAd = connect(mapStateToProps)(NativeAdUI);
